import { cn } from "../../utils";
import { LabelWithDescriptionProps } from "./types";

export const LabelWithDescription = ({
  label,
  description,
  disabled = false,
  labelClassName,
  descriptionClassName,
  labelWrapperClassName,
}: LabelWithDescriptionProps) => {
  return (
    <div className={cn("flex flex-col gap-2", labelWrapperClassName)}>
      {label && (
        <div
          className={cn(
            "text-text-general-neutral-mid font-normal text-sm",
            "group-has-[button:disabled]/radio-item:opacity-70",
            "group-has-[button:disabled]/checkbox-item:opacity-70",
            {
              "opacity-70": disabled,
            },
            labelClassName,
          )}
        >
          {label}
        </div>
      )}
      {description && (
        <div
          className={cn(
            "text-sm text-text-general-neutral-mild font-normal",
            descriptionClassName,
          )}
        >
          {description}
        </div>
      )}
    </div>
  );
};

LabelWithDescription.displayName = "LabelWithDescription";
